<template>
  <aha-modal
    :title="$i18nPresenter.t('The Quiz will not have a winner!')"
    @hide="$emit('hideModal')"
  >
    <div>
      {{ $i18nPresenter.t('Reveal the winner of the Quiz by adding a leaderboard after the last question.') }}
    </div>
    <template #action>
      <aha-button
        icon-name="add"
        @click="$emit('addQuiz')"
        has-margin-right
      >
        {{ $i18nPresenter.t('Add leaderboard') }}
      </aha-button>
      <aha-button
        variant="base"
        @click="$emit('hideModalAndMaybePresent')"
      >
        {{ $i18nPresenter.t('Present anyway') }}
      </aha-button>
    </template>
  </aha-modal>
</template>
<script>
export default {
  name: 'EditorHeaderPresentingNoLeaderboard',
}
</script>
